import React, { useState, useEffect, PureComponent } from "react";
import i18n from "i18next";
import { PieChart, Pie, Sector, Cell, BarChart, Bar } from "recharts";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import { fetchWrapper } from "../../../helpers/fetchwrapper";
import useWindowSize from "../../../helpers/useWindowSize";

import { baseUrl } from "../../../helpers/constants";
import { IConfiguratorStConfigCountPerDay } from "../../../Models/IConfiguratorStConfigCountPerDay";
import { IInquiryVolume } from "../../../Models/IInquiryVolume";
import { ILand } from "../../../Models/ILand";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { Button } from "@fluentui/react-components";
import { DataPieRegular } from "@fluentui/react-icons";
import Header from "../../Layout/Header";

function KpiDashboard(props: any) {
  const size = useWindowSize();

  const chartWidth = size.width > 500 ? 500 : size.width - 90;
  const cx = chartWidth / 2;
  const outerRadius = chartWidth / 4;
  const innerRadius = outerRadius - 20;

  const [activeUsersWeek, setActiveUsersWeek] = useState([
    { name: "Aktiv (Kunde)", value: 0 },
    { name: "Aktiv (Lübbering)", value: 0 },
    { name: "Inaktiv", value: 0 },
  ]);
  const [activeIndexUsersWeek, setActiveIndexUsersWeek] = useState(0);

  const [activeUsersMonth, setActiveUsersMonth] = useState([
    { name: "Aktiv (Kunde)", value: 0 },
    { name: "Aktiv (Lübbering)", value: 0 },
    { name: "Inaktiv", value: 0 },
  ]);
  const [activeIndexUsersMonth, setActiveIndexUsersMonth] = useState(0);

  const [top10RegisteredSchraubsysteme, setTop10RegisteredSchraubsysteme] =
    useState([]);
  const [signInPlatforms, setSignInPlatforms] = useState([]);
  const [moduleCountPerMonth, setModuleCountPerMonth] = useState([]);
  const [signInCountries, setSignInCountries] = useState([]);
  const [activeIndexSignInPlatform, setActiveIndexSignInPlatform] = useState(0);
  const [activeIndexSignInCountry, setActiveIndexSignInCountry] = useState(0);
  const [activeIndexTop10RegTool, setActiveIndexTop10RegTool] = useState(0);

  const [inquiryVolumeList, setInquiryVolumeList] = useState<IInquiryVolume[]>(
    [],
  );

  const [activeUserList, setActiveUserList] = useState([]);
  const [registeredSchraubsystemeList, setRegisteredSchraubsystemeList] =
    useState([]);

  const [configuratorStList, setConfiguratorStList] = useState<
    IConfiguratorStConfigCountPerDay[]
  >([]);

  const getActiveUsersWeek = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/kpi/GetActiveUserCountWeek`)
      .then((data: any) => {
        setActiveUsersWeek([
          { name: "Aktiv (Kunde)", value: data.activeCustomerUsers },
          { name: "Aktiv (Lübbering)", value: data.activeLuebberingUsers },
          { name: "Inaktiv", value: data.allUsers },
        ]);
      });
  };

  const getActiveUsersMonth = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/kpi/GetActiveUserCountMonth`)
      .then((data: any) => {
        setActiveUsersMonth([
          { name: "Aktiv (Kunde)", value: data.activeCustomerUsers },
          { name: "Aktiv (Lübbering)", value: data.activeLuebberingUsers },
          { name: "Inaktiv", value: data.allUsers },
        ]);
      });
  };

  const getConfiguratorStList = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/kpi/GetConfiguratorStList`)
      .then((data: IConfiguratorStConfigCountPerDay[]) => {
        const result = data.map((x: IConfiguratorStConfigCountPerDay) => {
          x.dateOfEntry = new Date(x.dateOfEntry).toLocaleDateString();
          return x;
        });
        setConfiguratorStList(result);
      });
  };

  //GetRegisteredSchraubsystemeList

  const getRegisteredSchraubsystemeList = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/kpi/GetRegisteredSchraubsystemeList`)
      .then((data: any) => {
        const result = data.map((x: any) => {
          x.dateOfEntry = new Date(x.dateOfEntry).toLocaleDateString();
          return x;
        });
        setRegisteredSchraubsystemeList(result);
      });
  };

  const getActiveUserList = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/kpi/GetActiveUserList`)
      .then((data: any) => {
        const result = data.map((x: any) => {
          x.dateOfEntry = new Date(x.dateOfEntry).toLocaleDateString();
          return x;
        });
        setActiveUserList(result);
      });
  };

  const getInquiryVolumeList = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/kpi/GetInquiryVolumeList`)
      .then((data: any) => {
        const result = data.map((x: IInquiryVolume) => {
          x.dateOfEntry = new Date(x.dateOfEntry).toLocaleDateString();

          return x;
        });
        setInquiryVolumeList(result);
      });
  };

  const getSignInPlatformList = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/kpi/GetSignInPlatformList`)
      .then((data: any) => {
        const result = data.map((x: any) => {
          x.name = x.key;
          return x;
        });
        setSignInPlatforms(result);
      });
  };

  const getSignInCountryList = () => {
    fetchWrapper
      .getWithAuth(baseUrl + "/api/laender/get")
      .then((laender: ILand[]) => {
        fetchWrapper
          .getWithAuth(`${baseUrl}/api/kpi/GetSignInCountryList`)
          .then((data: any) => {
            const result = data.map((x: any) => {
              const land = laender.find((land) => land.laendercode === x.key);
              x.name = i18n.language.includes("de")
                ? land?.name_DE
                : land?.name_EN;
              return x;
            });
            setSignInCountries(result);
          });
      });
  };

  const getAccessedModuleCountValue = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/kpi/GetAccessedModuleCountPerMonth`)
      .then((data: any) => {
        const result = data.map((x: any) => {
          x.dateOfEntry = new Date(x.dateOfEntry).toLocaleDateString();
          return x;
        });
        setModuleCountPerMonth(result);
      });
  };

  const getTop10RegisteredToolCompanys = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/kpi/GetTop10RegisteredToolCompanys`)
      .then((data: any) => {
        setTop10RegisteredSchraubsysteme(data);
      });
  };

  //GetTop10RegisteredToolCompanys()

  useEffect(() => {
    getActiveUsersWeek();
    getActiveUsersMonth();
    getActiveUserList();
    getRegisteredSchraubsystemeList();
    getConfiguratorStList();
    getInquiryVolumeList();
    getSignInPlatformList();
    getSignInCountryList();
    getAccessedModuleCountValue();
    getTop10RegisteredToolCompanys();
  }, []);

  const COLORS = [
    "#ff6600",
    "#80cee1",
    "#787878",
    "#6eb5ff",
    "#82ca9d",
    "#ababc9",
    "#d8bfd8",
    "#e6a8a1",
    "#deb887",
    "#fa8072",
    "#9400d3",
    "#7b68ee",
    "#3cb371",
  ];

  const renderActiveShape = (props: any) => {
    const RADIAN = Math.PI / 180;
    const {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload,
      percent,
      value,
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";

    return (
      <g>
        <text x={cx} y={cy} dy={8} width={50} textAnchor="middle" fill={fill}>
          {payload.name}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path
          d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
          stroke={fill}
          fill="none"
        />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          textAnchor={textAnchor}
          fill="#333"
        >{`${value}`}</text>
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          dy={18}
          textAnchor={textAnchor}
          fill="#999"
        >
          {`(${(percent * 100).toFixed(2)}%)`}
        </text>
      </g>
    );
  };

  const onPieEnterActiveUsersWeek = (_: any, index: any) => {
    setActiveIndexUsersWeek(index);
  };

  const onPieEnterActiveUsersMonth = (_: any, index: any) => {
    setActiveIndexUsersMonth(index);
  };

  const onPieEnterSignInPlatform = (_: any, index: any) => {
    setActiveIndexSignInPlatform(index);
  };

  const onPieEnterSignInCountry = (_: any, index: any) => {
    setActiveIndexSignInCountry(index);
  };

  const onPieEnterTop10RegTool = (_: any, index: any) => {
    setActiveIndexTop10RegTool(index);
  };

  return (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<DataPieRegular fontSize={24} color="#ff6600" />}
              size="large"
              appearance="subtle"
            >
              {i18n.t<string>("roleRequests").toLocaleUpperCase()}
            </Button>
          </StackShim>
        }
      />

      <div className="lueb-ContentBlock">
        <div className="lueb-WrapContainer500">
          <div className="lueb-KpiChart">
            <h6 className="lueb-centerTextHorizontal">
              Aktive Benutzer letzte 7 Tage
            </h6>
            <div style={{ width: "100%", height: 500 }}>
              <ResponsiveContainer>
                <PieChart>
                  <Pie
                    activeIndex={activeIndexUsersWeek}
                    activeShape={renderActiveShape}
                    data={activeUsersWeek}
                    cx={cx}
                    cy={cx}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    fill="#8884d8"
                    dataKey="value"
                    onMouseEnter={onPieEnterActiveUsersWeek}
                  >
                    {activeUsersWeek.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="lueb-KpiChart">
            <h6 className="lueb-centerTextHorizontal">
              Aktive Benutzer der letzten 30 Tage
            </h6>
            <div style={{ width: "100%", height: 500 }}>
              <ResponsiveContainer>
                <PieChart>
                  <Pie
                    activeIndex={activeIndexUsersMonth}
                    activeShape={renderActiveShape}
                    data={activeUsersMonth}
                    cx={cx}
                    cy={cx}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    fill="#8884d8"
                    dataKey="value"
                    onMouseEnter={onPieEnterActiveUsersMonth}
                  >
                    {activeUsersMonth.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="lueb-KpiChart">
            <h6 className="lueb-centerTextHorizontal">
              Top 10 Login-Platformen der letzten 30 Tage
            </h6>
            <div style={{ width: "100%", height: 550 }}>
              <ResponsiveContainer>
                <PieChart>
                  <Legend />
                  <Pie
                    activeIndex={activeIndexSignInPlatform}
                    activeShape={renderActiveShape}
                    data={signInPlatforms}
                    cx={cx}
                    cy={cx}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    fill="#8884d8"
                    dataKey="value"
                    onMouseEnter={onPieEnterSignInPlatform}
                  >
                    {signInPlatforms?.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="lueb-KpiChart">
            <h6 className="lueb-centerTextHorizontal">
              Top 10 Login-Länder der letzten 30 Tage
            </h6>
            <div style={{ width: "100%", height: 550 }}>
              <ResponsiveContainer>
                <PieChart>
                  <Legend />
                  <Pie
                    activeIndex={activeIndexSignInCountry}
                    activeShape={renderActiveShape}
                    data={signInCountries}
                    cx={cx}
                    cy={cx}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    fill="#8884d8"
                    dataKey="value"
                    onMouseEnter={onPieEnterSignInCountry}
                  >
                    {signInCountries?.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="lueb-KpiChart">
            <h6 className="lueb-centerTextHorizontal">
              Top 10 Firmen mit registrierten Schraubsystemen
            </h6>
            <div style={{ width: "100%", height: 550 }}>
              <ResponsiveContainer>
                <PieChart>
                  <Legend />
                  <Pie
                    activeIndex={activeIndexTop10RegTool}
                    activeShape={renderActiveShape}
                    data={top10RegisteredSchraubsysteme}
                    cx={cx}
                    cy={cx}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    fill="#8884d8"
                    dataKey="systemsCount"
                    onMouseEnter={onPieEnterTop10RegTool}
                  >
                    {top10RegisteredSchraubsysteme?.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        <div>
          <div className="lueb-KpiChart">
            <h6 className="lueb-centerTextHorizontal">
              Aktive Benutzer pro Tag
            </h6>
            <ResponsiveContainer width={"100%"} height={400}>
              <LineChart height={400} data={activeUserList}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="dateOfEntry" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line
                  name={i18n.t<string>("activeLuebberingUsers")}
                  type="monotone"
                  dataKey="activeLuebberingUsers"
                  stroke="#80cee1"
                  strokeWidth={2}
                />
                <Line
                  name={i18n.t<string>("activeCustomerUsers")}
                  type="monotone"
                  dataKey="activeCustomerUsers"
                  stroke="#ff6600"
                  strokeWidth={2}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>

          <div className="lueb-KpiChart">
            <h6 className="lueb-centerTextHorizontal">
              Gesamtzahl registrierte Schraubsysteme pro Monat
            </h6>
            <ResponsiveContainer width={"100%"} height={400}>
              <LineChart height={400} data={registeredSchraubsystemeList}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="dateOfEntry" />
                <YAxis />
                <Tooltip />
                <Line
                  name={i18n.t<string>("registeredSystemsToolbox")}
                  type="monotone"
                  dataKey="registeredSystemsToolbox"
                  stroke="#ff6600"
                  strokeWidth={2}
                />
                <Line
                  name={i18n.t<string>("registeredSystemsPartnerLounge")}
                  type="monotone"
                  dataKey="registeredSystemsPartnerLounge"
                  stroke="#80cee1"
                  strokeWidth={2}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>

          <div className="lueb-KpiChart">
            <h6 className="lueb-centerTextHorizontal">
              Anfrage-Volumen pro Monat in €
            </h6>
            <ResponsiveContainer width={"100%"} height={400}>
              <BarChart data={inquiryVolumeList}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="dateOfEntry" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar
                  name={i18n.t<string>("volumeBedarfe")}
                  dataKey="volumeBedarfe"
                  stackId="a"
                  fill="#ff6600"
                />
                <Bar
                  name={i18n.t<string>("volumeConfigurator")}
                  dataKey="volumeConfigurator"
                  stackId="a"
                  fill="#80cee1"
                />
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div className="lueb-KpiChart">
            <h6 className="lueb-centerTextHorizontal">
              Anzahl Aufrufe pro Modul pro Monat
            </h6>
            <ResponsiveContainer width={"100%"} height={400}>
              <BarChart data={moduleCountPerMonth}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="dateOfEntry" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar
                  name="Configurator"
                  dataKey="configurator"
                  stackId="a"
                  fill="#ff6600"
                />
                <Bar
                  name="QuickFinder"
                  dataKey="quickFinder"
                  stackId="a"
                  fill="#787878"
                />
                <Bar
                  name="Toolbox"
                  dataKey="toolbox"
                  stackId="a"
                  fill="#80cee1"
                />
                <Bar
                  name="Partner Lounge"
                  dataKey="partnerLounge"
                  stackId="a"
                  fill="#6eb5ff"
                />
                <Bar
                  name="Academy"
                  dataKey="academy"
                  stackId="a"
                  fill="#82ca9d"
                />
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div className="lueb-KpiChart">
            <h6 className="lueb-centerTextHorizontal">
              Konfigurator Ereignisse pro Tag
            </h6>
            <ResponsiveContainer width={"100%"} height={400}>
              <LineChart height={400} data={configuratorStList}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="dateOfEntry" />
                <YAxis />
                <Tooltip />
                <Legend />

                <Line
                  name={i18n.t<string>("configuratorStarted")}
                  type="monotone"
                  dataKey="started"
                  stroke="#ff6600"
                  strokeWidth={2}
                />

                <Line
                  name={i18n.t<string>("configuratorRestarted")}
                  type="monotone"
                  dataKey="restarted"
                  stroke="#deb887"
                  strokeWidth={2}
                />

                <Line
                  name={i18n.t<string>("configuratorFinished")}
                  type="monotone"
                  dataKey="finished"
                  stroke="#8884d8"
                  strokeWidth={2}
                />

                <Line
                  name={i18n.t<string>("configuratorSaved")}
                  type="monotone"
                  dataKey="saved"
                  stroke="#82ca9d"
                  strokeWidth={2}
                />

                <Line
                  name={i18n.t<string>("configuratorOfferRequested")}
                  type="monotone"
                  dataKey="offerRequested"
                  stroke="#6eb5ff"
                  strokeWidth={2}
                />

                <Line
                  name={i18n.t<string>("configuratorOfferSent")}
                  type="monotone"
                  dataKey="offerSent"
                  stroke="#ffabab"
                  strokeWidth={2}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KpiDashboard;
